// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__3n-FN","title":"style_title__jHIcs"};